export default __webpack_public_path__ + "static/mobil-trans-70-f906420edb6c80f1f64b501b92c59113.png";